// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"6a827b8c","428":"7894beab"}[chunkId] + ".chunk.css";
};